import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { IntegrateMainComponent } from './main/menu/integrate_menu.component';
import { Testimonial1Component } from './testimonials/testimonial1.component';
import { InstallSharedModule } from '../shared/install_shared.module';
import { SendToDeveloperComponent } from './dialog_content/send_to_developer.component';
import { DialogComponent } from '../dialog/dialog.component';
import DialogDynamicComponent from '../dialog/dialog_default.component';
import { InstallItMyselfComponent } from './dialog_content/install_it_myself.component';
import { InstallAutomaticallyApprovalComponent } from './dialog_content/install_automatically_approval.component';
import { InstallAutomaticallyComponent } from './dialog_content/install_automatically.component';
import { FormsModule } from '@angular/forms';
import { PostAutomaticInstallComponent } from './dialog_content/post_automatic_install.component';

@NgModule({
  imports: [
    CommonModule,
    InstallSharedModule,
    FormsModule
  ],
  declarations: [
    SendToDeveloperComponent,
    InstallItMyselfComponent,
    InstallAutomaticallyApprovalComponent,
    InstallAutomaticallyComponent,
    PostAutomaticInstallComponent,
    DialogComponent,
    DialogDynamicComponent,
    IntegrateMainComponent,
    Testimonial1Component
  ],
  providers: [
    TranslateService
  ]
})
export class IntegrateModule {};
